import React from 'react';

const COLOR = (share) => {
    if (share <= 0.4) return 'hsl(var(--good))';
    if (share <= 0.6) return 'hsl(var(--mustard))';
    return 'hsl(var(--bad))';
};

const wedge = (share) => {
    if (share >= 1) return null;
    const angle = share * 2 * Math.PI;
    const x = 20 + 14 * Math.sin(angle);
    const y = 20 - 14 * Math.cos(angle);
    return `M20 20 L20 6 A14 14 0 ${share > 0.5 ? 1 : 0} 1 ${x.toFixed(2)} ${y.toFixed(2)} Z`;
};

/**
 * A plate seen from above: the coloured slice is the part of the selling price
 * (excl. VAT) that goes to ingredients. An empty, dashed plate means no figure yet.
 */
const Plate = ({ share, size = 40 }) => {
    const known = share != null && Number.isFinite(share) && share > 0;
    const clamped = known ? Math.min(share, 1) : 0;
    const label = known ? `${Math.round(share * 100)} % du prix part en ingrédients` : 'Pas encore de chiffre';
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" role="img" aria-label={label} className="shrink-0">
            <title>{label}</title>
            <circle cx="20" cy="20" r="19" fill="hsl(var(--card))" stroke="hsl(var(--border))" strokeDasharray={known ? undefined : '3 3'} />
            <circle cx="20" cy="20" r="14" fill="hsl(var(--muted))" />
            {known && (clamped >= 1
                ? <circle cx="20" cy="20" r="14" fill={COLOR(share)} />
                : <path d={wedge(clamped)} fill={COLOR(share)} />)}
        </svg>
    );
};

export default Plate;
